import {
    Dialog,
    DialogActions,
    DialogTitle,
    Grid,
    IconButton,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as React from "react";
import hexToRGB from "utils/hexToRGB";
import AcxButton from "./AcxButton";
import GreenCheckSvg from "./Dialog/GreenCheckSvg";

type Props = {
    isOpen?: boolean;
    title?: string;
    subTitle?: string;
    confirmButtonText?: string;
    onClose: () => void;
    onConfirm?: any;
    fullWidth?: boolean;
    controlStyles?: React.CSSProperties;
};

function SuccessDialog(props: Props): React.ReactElement {
    return (
        <Dialog
            PaperProps={{
                sx: {
                    minHeight: "max-content",
                    minWidth: "500px",
                    borderRadius: "8px",
                },
            }}
            scroll={"paper"}
            open={props.isOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={props.fullWidth ?? false}
        >
            <DialogTitle id="alert-dialog-title">
                <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                >
                    <Grid item xs={10}>
                        <GreenCheckSvg />
                    </Grid>

                    <Grid container item xs={2} justifyContent="flex-end">
                        <IconButton
                            aria-label="close"
                            sx={{ color: (theme) => theme.palette.black.main }}
                            onClick={props.onClose}
                            size="large"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Grid>

                    <Grid item xs={10} style={{ paddingTop: "8px" }}>
                        <Typography
                            component="p"
                            variant="h1"
                            style={{ width: "90%" }}
                        >
                            {props.title || "Please Confirm..."}
                        </Typography>
                        {Boolean(props.subTitle) && (
                            <Typography
                                variant="subtitle2"
                                style={{ marginTop: "1rem" }}
                                color={"textSecondary"}
                            >
                                {props.subTitle}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
            </DialogTitle>

            <DialogActions
                sx={{
                    height: "64px",
                    backgroundColor: (theme) =>
                        hexToRGB(theme.palette.black.main, 0.05),
                }}
                style={props.controlStyles}
            >
                {props.onConfirm && (
                    <AcxButton
                        style={{ marginRight: "0.5rem" }}
                        onClick={props.onConfirm}
                        color="primary"
                    >
                        {props.confirmButtonText || "Confirm"}
                    </AcxButton>
                )}
            </DialogActions>
        </Dialog>
    );
}

export default SuccessDialog;
